import { render, staticRenderFns } from "./ColumnContentTab.vue?vue&type=template&id=043474d0&scoped=true"
import script from "./ColumnContentTab.vue?vue&type=script&lang=js"
export * from "./ColumnContentTab.vue?vue&type=script&lang=js"
import style0 from "./ColumnContentTab.vue?vue&type=style&index=0&id=043474d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043474d0",
  null
  
)

export default component.exports